import { __decorate as t, __classPrivateFieldGet as s, __classPrivateFieldSet as e } from "tslib";
import { LitElement as i, html as r } from "lit";
import { property as n } from "lit/decorators.js";
import l from "@inera/ids-design/components/form/spinner/spinner-lit.js";
var o, p, a;
class d extends i {
  constructor() {
    super(...arguments), o.set(this, "Laddar"), p.set(this, !1), a.set(this, "polite");
  }
  get srtext() {
    return s(this, o, "f");
  }
  set srtext(t) {
    e(this, o, t, "f");
  }
  get light() {
    return s(this, p, "f");
  }
  set light(t) {
    e(this, p, t, "f");
  }
  get live() {
    return s(this, a, "f");
  }
  set live(t) {
    e(this, a, t, "f");
  }
  render() {
    return r`<div role="alert" aria-live="${this.live}" class="${this.light ? "ids-spinner--light" : "ids-spinner"}"><p class="ids-spinner-sr">${this.srtext}</p><div class="ids-bounce-1"></div><div class="ids-bounce-2"></div><div class="ids-bounce-3"></div></div>`;
  }
}
o = new WeakMap(), p = new WeakMap(), a = new WeakMap(), d.styles = [l], t([n({
  type: String
})], d.prototype, "srtext", null), t([n({
  type: Boolean
})], d.prototype, "light", null), t([n({
  type: String
})], d.prototype, "live", null);
export { d as IDSSpinner };